import styled from 'styled-components';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

export const StyledStepper = styled(Stepper)``;
export const StyledStep = styled(Step)``;
export const StyledStepLabel = styled(StepLabel)``;
export const StyledStepContent = styled(StepContent)``;